import { Lock, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { Panel, Table, Pill, useLoad, act } from "@/components/common";

export function SignInSecurity() {
  const { data, reload } = useLoad(() => api.get("/admin/lockouts").then((r) => r.data));
  const unlock = (x) => act(api.post("/admin/lockouts/unlock", { email: x.email }), `${x.name} unlocked`).then(reload);
  return (
    <div className="space-y-6">
      <Panel title="Locked sign-ins" testid="lockouts-panel" action={<Button size="sm" variant="outline" data-testid="lockouts-refresh-btn" onClick={reload}>Refresh</Button>}>
        <p className="mb-3 flex items-center gap-2 text-xs text-slate-500"><Lock className="h-3.5 w-3.5" />After 5 wrong passwords an account is locked for 15 minutes. System Administrators and PMO get an email and an in-app alert each time. Only a System Administrator can unlock another administrator.</p>
        <Table rows={data?.locked || []} empty="Nobody is locked out right now" cols={[{ k: "name", h: "Name" }, { k: "email", h: "Email" }, { k: "role_label", h: "Role" },
          { k: "attempts", h: "Failed attempts" }, { k: "locked_until", h: "Unlocks by itself at", r: (x) => new Date(x.locked_until).toLocaleTimeString() },
          { k: "act", h: "", r: (x) => x.can_unlock ? <Button size="sm" className="h-7 text-xs" data-testid={`unlock-${x.email}`} onClick={() => unlock(x)}>Unlock now</Button> : <span className="text-xs text-slate-400">Admin only</span> }]} />
      </Panel>
      <Panel title="Sign-in codes by text message" testid="sms-status-panel">
        <div className="flex items-start gap-3 text-sm">
          <MessageSquare className="mt-0.5 h-5 w-5 text-indigo-600" />
          <div>
            <div className="mb-1">Status: <Pill tone={data?.sms_connected ? "green" : "amber"} testid="sms-status">{data?.sms_connected ? "connected (Twilio)" : "not connected yet"}</Pill></div>
            <p className="text-xs text-slate-500">Admins and Finance users can tap "Text me a code instead" when signing in, if their account has a mobile number (set it under Users). {data?.sms_connected ? "" : "Texts start working as soon as the Twilio account SID, auth token and sender number are added."}</p>
          </div>
        </div>
      </Panel>
    </div>
  );
}
